(() => {
  if (!document.body.classList.contains('template-index') || window.galixHomeFlowInitialized) return;
  window.galixHomeFlowInitialized = true;

  const definitions = [
    { root: '.galix-hero', hero: true, parts: [['.galix-hero__content', 0, 'intro']] },
    { root: '.galix-comparison', parts: [['.galix-container', 0, 'visual']] },
    { root: '.galix-benefits', parts: [['.galix-benefits__inner', 0, 'intro'], ['.galix-cinema-camera', .15, 'visual']] },
    { root: '.galix-packs', parts: [['.galix-section__intro', 0, 'intro'], ['.galix-packs__grid', .15, 'visual']] },
    { root: '.galix-worlds', parts: [['.galix-worlds__intro', 0, 'intro'], ['.galix-worlds__composition', .15, 'visual']] },
    { root: '.galix-uses', parts: [['.galix-section__intro', 0, 'intro'], ['.galix-uses__mosaic', .15, 'visual']] },
    { root: '.galix-how', parts: [['.galix-how__intro', 0, 'intro'], ['.galix-how__steps', .15, 'visual']] },
    { root: '.galix-families', parts: [['.galix-container', 0, 'visual']] },
    { root: '.galix-faq', parts: [['.galix-faq__inner', 0, 'visual']] }
  ];
  const instances = new Map();
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;

  const clamp = (value) => Math.max(0, Math.min(1, value));
  const smooth = (value) => value * value * (3 - 2 * value);
  const state = (value) => value <= .001 ? '0' : value >= .999 ? '1' : value.toFixed(3);

  function draw() {
    frame = 0;
    if (preference.matches) return;

    const viewport = innerHeight;
    const mobile = innerWidth < 990;
    const reads = [];

    instances.forEach((instance, section) => {
      const rect = section.getBoundingClientRect();
      const entering = instance.hero ? 1 : clamp((viewport * .94 - rect.top) / (viewport * .66));
      const leaving = clamp((viewport * .66 - rect.bottom) / (viewport * .42));
      reads.push({ instance, section, entering, leaving: smooth(leaving) });
    });

    reads.forEach(({ instance, section, entering, leaving }) => {
      const enter = smooth(entering);
      const enterState = state(enter);
      const exitState = state(leaving);
      if (section.dataset.flowEnter === enterState && section.dataset.flowExit === exitState) return;
      section.dataset.flowEnter = enterState;
      section.dataset.flowExit = exitState;

      instance.parts.forEach(({ element, lag, role }) => {
        const arrival = instance.hero ? 1 : smooth(clamp((entering - lag) / (1 - lag)));
        const entranceLift = mobile ? (role === 'intro' ? 18 : 28) : (role === 'intro' ? 30 : 46);
        const exitLift = mobile ? (role === 'intro' ? 11 : 17) : (role === 'intro' ? 17 : 28);
        const offset = instance.hero ? -leaving * exitLift : (1 - arrival) * entranceLift - leaving * exitLift;
        const baseOpacity = instance.hero ? 1 : (role === 'intro' ? .48 : .35) + arrival * (role === 'intro' ? .52 : .65);
        const opacity = baseOpacity * (1 - leaving * (role === 'intro' ? .35 : .3));
        const active = (entering > 0 && entering < 1) || (leaving > 0 && leaving < 1);

        element.style.setProperty('--galix-flow-y', `${offset.toFixed(2)}px`);
        element.style.setProperty('--galix-flow-opacity', opacity.toFixed(3));
        element.dataset.flowActive = String(active);
      });
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(draw);
  }

  function mount(scope = document) {
    if (preference.matches) return;
    definitions.forEach((definition) => {
      const roots = scope.matches?.(definition.root) ? [scope] : scope.querySelectorAll(definition.root);
      roots.forEach((section) => {
        if (instances.has(section)) return;
        const parts = definition.parts.map(([selector, lag, role]) => ({ element: section.querySelector(selector), lag, role }));
        if (parts.some(({ element }) => !element)) return;
        section.dataset.galixFlow = '';
        parts.forEach(({ element, role }) => { element.dataset.galixFlowPart = role; });
        instances.set(section, { hero: Boolean(definition.hero), parts });
      });
    });
    draw();
  }

  function unmount(scope) {
    instances.forEach((instance, section) => {
      if (scope !== section && !scope.contains(section)) return;
      delete section.dataset.galixFlow;
      delete section.dataset.flowEnter;
      delete section.dataset.flowExit;
      instance.parts.forEach(({ element }) => {
        delete element.dataset.galixFlowPart;
        delete element.dataset.flowActive;
        element.style.removeProperty('--galix-flow-y');
        element.style.removeProperty('--galix-flow-opacity');
      });
      instances.delete(section);
    });
  }

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', () => {
    instances.forEach((instance, section) => { delete section.dataset.flowEnter; });
    schedule();
  }, { passive: true });
  preference.addEventListener('change', () => preference.matches ? unmount(document) : mount());
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
  mount();
})();
